<template>
  <div style="padding: 20px 40px 40px 40px;">
    <Header title="Dashboard" smallTitle="Demo" />
    <b-row>
      <b-col>
        <b-card
          border-variant="primary"
          header="Visitors (Daily)" 
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
        >
          <b-row no-gutters>
            <b-col md="6">
              <div style="font-size: 3vw;">15</div>
              <div>Total</div>
              <div style="font-size: 3vw;">2</div>
              <div>Long Waiting Time</div>
              <div style="font-size: 3vw;">3</div>
              <div>Without Pre-Authorization</div>
            </b-col>
            <b-col md="6">
              <div style="font-size: 10vw;">10</div>
              <div style="font-size: 2vw;">Active</div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col>
        <b-card border-variant="warning" header="Safety (Monthly)" header-bg-variant="warning" align="center">
          <b-row no-gutters>
            <b-col md="6">
              <div style="font-size: 2vw; margin: 15px;">Unsafe Acts: 32</div>
              <div style="font-size: 2vw; margin: 15px;">Unsafe Conditions: 19</div>
              <div style="font-size: 2vw; margin: 15px;">Internal Faults: 24</div>
              <div style="font-size: 2vw; margin: 15px;">External Faults: 27</div>
            </b-col>
            <b-col md="6">
              <div style="font-size: 10vw;">51</div>
              <div style="font-size: 2vw;">Total</div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";

export default {
  name: "Dashboard",
  components: {
    Header
  }
};
</script>